import React from 'react';
import styled, { css } from 'styled-components';
import { variables } from 'styleUtils';

import { defaultButtonStyle } from '../Button';

const StyledRadio = styled.input`
  position: absolute;
  opacity: 0;
  cursor: ${props => props.disabled ? 'wait' : 'pointer' };
  height: 0;
  width: 0;
`;

const RadioContainer = styled.label`
  ${props => defaultButtonStyle(props)}
  position: relative;
  text-align: center;
  min-width: 150px;

  ${props => props.checked ? css`
    background-color: ${variables.darkGrey};
    color: ${variables.white};
    :hover {
      background-color: ${variables.darkGrey};
    }
  ` : css`
    border: solid 1px ${variables.darkGrey};
    background-color: transparent;
    color: ${variables.darkGrey};
    box-shadow: 0px 0px 0px 1px ${variables.lineColor};
    transition: box-shadow 0.3s ease 0s, border-color .3s ease 0s;
    :hover {
      background: transparent;
      color: ${variables.darkGrey};
      box-shadow: ${props => props.disabled ? `0px 0px 0px 1px ${variables.lineColor}` : `0px 0px 0px 3px ${variables.darkGrey}`};
      border-color: ${variables.darkGrey};
      transition: box-shadow 0.3s ease 0s, border-color .3s ease 0s;
    }
  `}

  ${props => props.disabled && css`
  `}
`;

const Radio = ({
	checked, label, value, name, onChange, disabled,
}) => (
	<RadioContainer checked={checked} disabled={disabled}>
		{label}
		<StyledRadio
			value={value}
			name={name}
			type='radio'
			disabled={disabled}
			onChange={onChange}
		/>
	</RadioContainer>
);

export default Radio;
